import axios from 'axios';
import urls from '@/api/urls';
import codes from '@/api/codes';
// import {message} from 'ant-design-vue'
import { Toast } from 'vant';

const HttpClient = {
  init(option) {
    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers['Access-Control-Allow-Method'] = '*';
    axios.defaults.baseURL = urls.BASE_URL;
    axios.defaults.timeout = 0; // 默认超时时间
    axios.interceptors.request.use((config) => {
      config.url += config.url.indexOf('?') > 0 ? '&' : '?';
      config.url += 'timestamp=' + new Date().getTime();
      return config;
    });
    axios.interceptors.response.use(
      (res) => {
        if (res.data.code === codes.SUCCESS) {
          return res.data.data;
        } else {
          return Promise.reject(res);
        }
      },
      (error) => {
        // message.error('服务器出错！')
        Toast.error('服务器出错');
        return Promise.reject(error);
      }
    );
  },
};

export { HttpClient };

export default axios;



// WEBPACK FOOTER //
// ./src/api/client.js